const API_BASE = import.meta.env.VITE_API_BASE_URL as string

export interface LicenseItem {
  licenseId: string
  status: 'PENDING' | 'ACTIVE' | 'REVOKED'
  licenseKey: string
  boundAccountId?: string
  boundRegion?: string
  issuedAt: string
  activatedAt?: string
}

export interface CustomerLicenses {
  customerId: string
  subscriptionStatus: 'ACTIVE' | 'CANCELLED'
  licenses: LicenseItem[]
}

export interface GetLicensesResponse {
  customers: CustomerLicenses[]
}

export interface ClaimResponse {
  customerId: string
  licenses: LicenseItem[]
}

async function apiFetch<T>(
  path: string,
  accessToken: string,
  options?: RequestInit
): Promise<{ ok: true; data: T } | { ok: false; status: number; error: string }> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
      ...(options?.headers as Record<string, string>)
    }
  })

  if (res.ok) {
    const data = (await res.json()) as T
    return { ok: true, data }
  }

  let error = `HTTP ${res.status}`
  try {
    const body = (await res.json()) as { error?: string }
    if (body.error) error = body.error
  } catch {
    // ignore
  }
  return { ok: false, status: res.status, error }
}

export async function claimLicense(
  claimToken: string,
  accessToken: string
): Promise<{ ok: true; data: ClaimResponse } | { ok: false; status: number; error: string }> {
  return apiFetch<ClaimResponse>('/claim', accessToken, {
    method: 'POST',
    body: JSON.stringify({ claimToken })
  })
}

export async function getLicenses(
  accessToken: string
): Promise<{ ok: true; data: GetLicensesResponse } | { ok: false; status: number; error: string }> {
  return apiFetch<GetLicensesResponse>('/licenses', accessToken)
}

export async function createLicense(
  customerId: string,
  accessToken: string
): Promise<{ ok: true; data: LicenseItem } | { ok: false; status: number; error: string }> {
  return apiFetch<LicenseItem>('/licenses', accessToken, {
    method: 'POST',
    body: JSON.stringify({ customerId })
  })
}
